import { CaseDocument } from "../types";

interface UploadedFileListProps {
  files: CaseDocument[];
}

const UploadedFileList: React.FC<UploadedFileListProps> = ({ files }) => {
  return (
    <div className="mt-4">
      <h3 className="mb-2 text-sm font-medium">Uploaded files:</h3>
      {files.length === 0 && (
        <p className="text-sm text-gray-600">No files uploaded yet.</p>
      )}
      <ul className="space-y-2">
        {files.map((file) => (
          <li
            key={file.uuid}
            className="group flex items-center justify-between rounded bg-gray-50 p-2 text-sm"
          >
            <div className="flex items-center">
              <svg
                className="mr-2 h-5 w-5 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span className="mr-2 font-medium">{file.kindLabel}</span>
              <span className="max-w-xs truncate">{file.name}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UploadedFileList;
